import { ItemCheckResult } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import { HydratedProposal } from 'entities/Proposal/model/types/ProposalSchema';
import { Vendor } from 'entities/Vendors';

/**
 * Converts an ItemCheckResult to a HydratedProposal format for display
 * @param checkResult - The check result from allCheckResults
 * @param vendorsMap - Map of vendors by externalUuid
 * @returns A HydratedProposal object
 */
export const convertCheckResultToProposal = (
    checkResult: ItemCheckResult,
    vendorsMap: Record<string, Vendor> | undefined,
): HydratedProposal => {
    const vendor = vendorsMap?.[checkResult.sellerUid];

    return {
        condition: '',
        externalInvId: checkResult.sellerSku,
        invId: checkResult.invUid,
        isActive: true,
        isUnlimitedQuantity: false,
        prices: {
            discount: 0,
            freight: 0,
            subtotal: checkResult.sellPrice,
            total: checkResult.sellPrice,
            tax: 0,
            price: checkResult.sellPrice,
        },
        quantity: checkResult.availableQuantity,
        seller: {
            name: vendor?.title || '',
            paId: '',
            parId: '',
            uid: checkResult.sellerUid,
        },
        uid: checkResult.invUid,
        units: '',
        isOutOfStock: checkResult.availableQuantity <= 0,
        productSourcingMode: '',
        hydratedVendor: vendor,
        selectedProposal: null, // These are unselected proposals
        sellPrice: checkResult.sellPrice,
        availableQuantity: checkResult.availableQuantity,
    };
};
